import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={830}
    height={414}
    viewBox="0 0 830 414"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M829 1C811.604 26.2451 786.298 52.6434 755.5 55.6856C734 57.8093 683.5 41.8814 638.5 48.7835C593.5 55.6856 563.5 139.041 530.5 165.057C497.5 191.072 498.5 132.139 455 140.634C411.5 149.129 424.5 199.036 392 223.459C359.5 247.881 319 256.907 285.5 270.18C252 283.454 234 355.66 188.5 380.082C143 404.505 1 413 1 413"
      stroke="url(#paint0_linear_30_42)"
    />
    <circle
      cx={318.797}
      cy={264.797}
      r={16.0291}
      transform="rotate(-26.1826 318.797 264.797)"
      stroke="url(#paint1_linear_30_42)"
    />
    <circle
      cx={318.797}
      cy={264.797}
      r={23.9001}
      transform="rotate(-26.1826 318.797 264.797)"
      stroke="url(#paint2_linear_30_42)"
    />
    <circle
      cx={318.977}
      cy={264.27}
      r={32.9518}
      transform="rotate(-26.1826 318.977 264.27)"
      stroke="url(#paint3_linear_30_42)"
    />
    <circle
      cx={318.797}
      cy={264.797}
      r={42.7906}
      transform="rotate(-26.1826 318.797 264.797)"
      stroke="url(#paint4_linear_30_42)"
    />
    <circle
      cx={319.31}
      cy={265.31}
      r={9.3098}
      fill="url(#paint5_radial_30_42)"
    />
    <circle
      cx={319.31}
      cy={265.31}
      r={9.3098}
      fill="url(#paint6_radial_30_42)"
      fillOpacity={0.2}
    />
    <circle
      cx={319.31}
      cy={265.31}
      r={9.3098}
      fill="url(#paint7_radial_30_42)"
      fillOpacity={0.2}
    />
    <circle
      cx={0.348248}
      cy={0.348248}
      r={0.348248}
      transform="matrix(-0.909574 0.415541 0.415541 0.909574 323.453 263.609)"
      fill="#0C102B"
    />
    <circle
      cx={0.348248}
      cy={0.348248}
      r={0.348248}
      transform="matrix(-0.909574 0.415541 0.415541 0.909574 318.272 264.306)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M319.974 265.973C319.968 266.078 320.049 266.167 320.153 266.173C320.429 266.187 320.938 266.112 321.379 265.974C321.601 265.905 321.819 265.816 321.987 265.705C322.147 265.6 322.311 265.443 322.322 265.225C322.328 265.121 322.248 265.031 322.143 265.026C322.038 265.02 321.949 265.1 321.943 265.205C321.941 265.233 321.914 265.298 321.779 265.387C321.652 265.471 321.472 265.547 321.266 265.612C320.851 265.741 320.389 265.805 320.174 265.793C320.069 265.788 319.98 265.868 319.974 265.973Z"
      fill="black"
    />
    <ellipse
      cx={317.241}
      cy={259.448}
      rx={1.03442}
      ry={1.37923}
      transform="rotate(49.0436 317.241 259.448)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={319.52}
      cy={257.923}
      rx={0.333607}
      ry={0.444809}
      transform="rotate(77.028 319.52 257.923)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={312.758}
      cy={264.965}
      rx={1.37923}
      ry={2.06884}
      transform="rotate(4.36064 312.758 264.965)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={313.234}
      cy={265.347}
      rx={2.50949}
      ry={3.76423}
      transform="rotate(7.20987 313.234 265.347)"
      fill="white"
      fillOpacity={0.06}
    />
    <path
      d="M285.5 288.515C252 300.085 234 363.021 188.5 384.308C143 405.596 1.00024 413 1.00024 413H829V53.8919C811.604 75.8961 786.298 98.9054 755.5 101.557C734 103.408 683.5 89.525 638.5 95.541C593.5 101.557 563.5 174.212 530.5 196.887C497.5 219.563 498.5 168.196 455 175.6C411.5 183.004 424.5 226.504 392 247.792C359.5 269.079 319 276.946 285.5 288.515Z"
      fill="url(#paint8_linear_30_42)"
    />
    <path
      d="M829 53.8919C811.604 75.8961 786.298 98.9054 755.5 101.557C734 103.408 683.5 89.525 638.5 95.541C593.5 101.557 563.5 174.212 530.5 196.887C497.5 219.563 498.5 168.196 455 175.6C411.5 183.004 424.5 226.504 392 247.792C359.5 269.079 319 276.946 285.5 288.515C252 300.085 234 363.021 188.5 384.308C143 405.596 1.00024 413 1.00024 413"
      stroke="url(#paint9_linear_30_42)"
      strokeWidth={2}
    />
    <path
      d="M785.583 100.195C810.535 92.8129 829 103.536 829 103.536V413L303 410.232C303 410.232 400.814 269.054 447.226 254.752C493.638 240.45 490.643 270.9 522.583 260.75C554.522 250.6 571.49 188.777 609.417 178.165C647.345 167.554 647.345 192.929 682.279 178.165C717.213 163.402 760.63 107.577 785.583 100.195Z"
      fill="url(#paint10_linear_30_42)"
    />
    <path
      d="M829 103.536C829 103.536 810.535 92.8129 785.583 100.195C760.63 107.577 717.213 163.402 682.279 178.165C647.345 192.929 647.345 167.554 609.417 178.165C571.49 188.777 554.522 250.6 522.583 260.75C490.643 270.9 493.638 240.45 447.226 254.752C400.814 269.054 303 410.232 303 410.232"
      stroke="url(#paint11_linear_30_42)"
      strokeWidth={2}
    />
    <path
      d="M273 305.021C247 321.171 215 375.161 178 386.697C141 398.234 1.00024 413 1.00024 413H827L829 269.171C829 269.171 696 342.398 635.5 333.169C575 323.94 560 137.515 501 142.129C442 146.744 440.5 229.805 395.5 263.029C350.5 296.253 299 288.87 273 305.021Z"
      fill="url(#paint12_linear_30_42)"
    />
    <circle
      cx={386.563}
      cy={300.563}
      r={11.8907}
      transform="rotate(-105 386.563 300.563)"
      fill="url(#paint13_radial_30_42)"
    />
    <circle
      cx={0.666667}
      cy={0.666667}
      r={0.666667}
      transform="matrix(-1 0 0 1 395 298.667)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M387.93 298.48C387.84 298.319 387.637 298.262 387.476 298.352C386.192 299.073 384.567 298.616 383.846 297.332C383.756 297.172 383.553 297.115 383.392 297.205C383.232 297.295 383.174 297.498 383.265 297.658C384.166 299.264 386.197 299.835 387.803 298.934C387.963 298.844 388.02 298.641 387.93 298.48Z"
      fill="black"
    />
    <circle
      cx={0.666667}
      cy={0.666667}
      r={0.666667}
      transform="matrix(-1 0 0 1 380.333 294)"
      fill="#0C102B"
    />
    <path
      d="M829 269.171C829 269.171 696 342.398 635.5 333.169C575 323.94 560 137.515 501 142.129C442 146.744 440.5 229.805 395.5 263.029C350.5 296.253 299 288.87 273 305.021C247 321.171 215 375.161 178 386.697C141 398.234 1.00024 413 1.00024 413"
      stroke="url(#paint14_linear_30_42)"
      strokeWidth={2}
    />
    <path
      d="M495 167C495 164.239 497.239 162 500 162H505C507.761 162 510 164.239 510 167V413H495V167Z"
      fill="url(#paint15_linear_30_42)"
    />
    <path
      d="M510 210C510 207.239 512.239 205 515 205H520C522.761 205 525 207.239 525 210V413H510V210Z"
      fill="url(#paint16_linear_30_42)"
    />
    <path
      d="M525 190C525 187.239 527.239 185 530 185H535C537.761 185 540 187.239 540 190V413H525V190Z"
      fill="url(#paint17_linear_30_42)"
    />
    <path
      d="M540 223C540 220.239 542.239 218 545 218H550C552.761 218 555 220.239 555 223V413H540V223Z"
      fill="url(#paint18_linear_30_42)"
    />
    <path
      d="M555 252C555 249.239 557.239 247 560 247H565C567.761 247 570 249.239 570 252V413H555V252Z"
      fill="url(#paint19_linear_30_42)"
    />
    <ellipse
      cx={178.421}
      cy={301.585}
      rx={2.0882}
      ry={1.91418}
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.93}
      cx={191.637}
      cy={294.094}
      r={1.5398}
      transform="rotate(138 191.637 294.094)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.86}
      cx={272.606}
      cy={270.272}
      r={1.62646}
      transform="rotate(-126 272.606 270.272)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.7}
      cx={331.567}
      cy={297.303}
      r={2.1064}
      transform="rotate(67 331.567 297.303)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.79}
      cx={165.3}
      cy={338.913}
      r={1.19985}
      transform="rotate(-16 165.3 338.913)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.81}
      cx={209.709}
      cy={324.478}
      r={2.27971}
      transform="rotate(140 209.709 324.478)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      cx={339.438}
      cy={324.697}
      r={2.79964}
      transform="rotate(100 339.438 324.697)"
      fill="#CEF6FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.93}
      cx={112.244}
      cy={364.156}
      r={3.03961}
      transform="rotate(176 112.244 364.156)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.89}
      cx={229.501}
      cy={359.545}
      r={3.09294}
      transform="rotate(114 229.501 359.545)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.72}
      cx={349.601}
      cy={359.171}
      r={2.613}
      transform="rotate(177 349.601 359.171)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.89}
      cx={236.932}
      cy={351.555}
      r={1.76408}
      transform="rotate(114 236.932 351.555)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.85}
      cx={268.391}
      cy={263.537}
      r={1.21495}
      transform="rotate(141 268.391 263.537)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      cx={275.98}
      cy={289.29}
      rx={0.987078}
      ry={0.904821}
      transform="rotate(97 275.98 289.29)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.99}
      cx={305.807}
      cy={243.303}
      r={1.02341}
      transform="rotate(95 305.807 243.303)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.79}
      cx={293.234}
      cy={238.736}
      rx={1.13514}
      ry={1.04054}
      transform="rotate(-47 293.234 238.736)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.76}
      cx={332.463}
      cy={246.96}
      rx={0.769921}
      ry={0.705761}
      transform="rotate(62 332.463 246.96)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.94}
      cx={465.562}
      cy={239.289}
      r={0.895802}
      transform="rotate(44 465.562 239.289)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      cx={232.402}
      cy={258.17}
      r={1.14205}
      transform="rotate(-3 232.402 258.17)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.99}
      cx={337.256}
      cy={251.167}
      rx={0.967336}
      ry={0.886725}
      transform="rotate(141 337.256 251.167)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.77}
      cx={495.279}
      cy={260.655}
      r={1.35834}
      transform="rotate(54 495.279 260.655)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      cx={297.552}
      cy={269.94}
      r={1.04388}
      transform="rotate(-100 297.552 269.94)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <circle
      cx={409.743}
      cy={271.854}
      r={0.736856}
      transform="rotate(119 409.743 271.854)"
      fill="white"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.73}
      cx={530.084}
      cy={269.535}
      r={1.14205}
      transform="rotate(-28 530.084 269.535)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.87}
      cx={218.233}
      cy={280.798}
      r={0.716388}
      transform="rotate(47 218.233 280.798)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.86}
      cx={365.934}
      cy={276}
      r={0.923359}
      transform="rotate(-124 365.934 276)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.82}
      cx={538.004}
      cy={275.375}
      r={0.764066}
      transform="rotate(-142 538.004 275.375)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.88}
      cx={243.729}
      cy={297.247}
      rx={0.898241}
      ry={0.823387}
      transform="rotate(90 243.729 297.247)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.87}
      cx={351.318}
      cy={277.318}
      r={1.07609}
      transform="rotate(-75 351.318 277.318)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.71}
      cx={462.651}
      cy={299.159}
      r={1.33644}
      transform="rotate(165 462.651 299.159)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.72}
      cx={244.875}
      cy={312.198}
      rx={1.10553}
      ry={1.0134}
      transform="rotate(-3 244.875 312.198)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.81}
      cx={416.041}
      cy={315.837}
      r={0.91121}
      transform="rotate(32 416.041 315.837)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.96}
      cx={545.171}
      cy={310.111}
      r={1.14622}
      transform="rotate(-152 545.171 310.111)"
      fill="#233987"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.75}
      cx={325.403}
      cy={325.192}
      r={0.838313}
      transform="rotate(29 325.403 325.192)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.79}
      cx={333.155}
      cy={318.557}
      r={0.984106}
      transform="rotate(-117 333.155 318.557)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.94}
      cx={491.008}
      cy={323.98}
      r={0.862612}
      transform="rotate(-177 491.008 323.98)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.94}
      cx={254.571}
      cy={329.22}
      r={0.904584}
      transform="rotate(-94 254.571 329.22)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.94}
      cx={397}
      cy={335.074}
      r={1.19957}
      transform="rotate(-49 397 335.074)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.91}
      cx={462.976}
      cy={342.633}
      r={0.597201}
      transform="rotate(20 462.976 342.633)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.91}
      cx={218.43}
      cy={346.494}
      r={0.850462}
      transform="rotate(79 218.43 346.494)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.82}
      cx={362.544}
      cy={344.914}
      r={1.1542}
      transform="rotate(68 362.544 344.914)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.95}
      cx={554.919}
      cy={355.758}
      r={0.767558}
      transform="rotate(40 554.919 355.758)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <circle
      opacity={0.74}
      cx={212.311}
      cy={356.871}
      r={1.2271}
      transform="rotate(97 212.311 356.871)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.88}
      cx={389.232}
      cy={361.708}
      rx={1.06604}
      ry={0.977207}
      transform="rotate(23 389.232 361.708)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <path
      d="M76.1361 326.09C23.0399 323.588 1 358.603 1 358.603V413H829V259.187C752.326 259.187 683.976 390.912 609.603 400.495C531.962 410.499 509.841 247.452 457.828 251.059C430.779 252.935 412.746 312.334 388.202 313.584C363.657 314.835 337.109 292.326 294.532 294.827C251.955 297.328 220.397 354.226 185.835 358.603C151.272 362.98 129.232 328.591 76.1361 326.09Z"
      fill="url(#paint20_linear_30_42)"
    />
    <path
      d="M1 358.603C1 358.603 23.0399 323.588 76.1361 326.09C129.232 328.591 151.272 362.98 185.835 358.603C220.397 354.226 251.955 297.328 294.532 294.827C337.109 292.326 363.657 314.835 388.201 313.584C412.746 312.334 430.779 252.935 457.828 251.059C509.841 247.452 531.962 410.499 609.603 400.495C683.976 390.912 752.326 259.187 829 259.187"
      stroke="url(#paint21_linear_30_42)"
      strokeWidth={2}
    />
    <path
      d="M76.1361 348.622C23.0399 346.769 1 372.706 1 372.706V413H829V299.065C752.326 299.065 683.976 396.638 609.603 403.737C531.962 411.147 509.841 290.372 457.828 293.044C430.779 294.433 412.746 338.433 388.202 339.359C363.657 340.285 337.109 323.612 294.532 325.464C251.955 327.317 220.397 369.464 185.835 372.706C151.272 375.948 129.232 350.475 76.1361 348.622Z"
      fill="url(#paint22_linear_30_42)"
    />
    <path
      d="M1 372.706C1 372.706 23.0399 346.769 76.1361 348.622C129.232 350.475 151.272 375.948 185.835 372.706C220.397 369.464 251.955 327.317 294.532 325.464C337.109 323.612 363.657 340.285 388.201 339.359C412.746 338.433 430.779 294.433 457.828 293.044C509.841 290.372 531.962 411.147 609.603 403.737C683.976 396.638 752.326 299.065 829 299.065"
      stroke="url(#paint23_linear_30_42)"
      strokeWidth={2}
    />
    <circle
      cx={673}
      cy={265}
      r={20.5}
      transform="rotate(-133.325 673 265)"
      stroke="url(#paint24_linear_30_42)"
    />
    <circle
      cx={673}
      cy={265}
      r={30.5}
      transform="rotate(-133.325 673 265)"
      stroke="url(#paint25_linear_30_42)"
    />
    <circle
      cx={672.293}
      cy={264.979}
      r={42}
      transform="rotate(-133.325 672.293 264.979)"
      stroke="url(#paint26_linear_30_42)"
    />
    <circle
      cx={673}
      cy={265}
      r={54.5}
      transform="rotate(-133.325 673 265)"
      stroke="url(#paint27_linear_30_42)"
    />
    <circle
      cx={674.5}
      cy={264.5}
      r={11.9248}
      transform="rotate(33.0706 674.5 264.5)"
      fill="url(#paint28_radial_30_42)"
    />
    <circle
      cx={674.5}
      cy={264.5}
      r={11.9248}
      transform="rotate(33.0706 674.5 264.5)"
      fill="url(#paint29_radial_30_42)"
      fillOpacity={0.2}
    />
    <circle
      cx={674.5}
      cy={264.5}
      r={11.9248}
      transform="rotate(33.0706 674.5 264.5)"
      fill="url(#paint30_radial_30_42)"
      fillOpacity={0.2}
    />
    <path
      d="M686.28 262.65C685.548 259.901 683.836 257.403 681.265 255.729C675.746 252.136 668.359 253.696 664.765 259.215C663.091 261.786 662.535 264.763 662.978 267.573C662.139 264.422 662.588 260.941 664.507 257.993C668.101 252.474 675.488 250.913 681.007 254.507C683.955 256.427 685.773 259.428 686.28 262.65Z"
      fill="url(#paint31_linear_30_42)"
    />
    <ellipse
      cx={676.376}
      cy={256.762}
      rx={1.32498}
      ry={1.76664}
      transform="rotate(82.1142 676.376 256.762)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={679.888}
      cy={256.717}
      rx={0.427312}
      ry={0.56975}
      transform="rotate(110.099 679.888 256.717)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={667.709}
      cy={259.551}
      rx={1.76664}
      ry={2.64996}
      transform="rotate(37.4313 667.709 259.551)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={667.952}
      cy={260.293}
      rx={3.21437}
      ry={4.82155}
      transform="rotate(40.2805 667.952 260.293)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle cx={670.426} cy={266.4} r={0.70523} fill="#0C102B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M677.417 268.368C677.417 268.368 677.416 268.369 677.416 268.371C677.416 268.369 677.417 268.368 677.417 268.368ZM677.408 268.388C677.391 268.36 677.345 268.303 677.225 268.231C677.015 268.106 676.676 268.003 676.261 268.003C675.845 268.003 675.506 268.106 675.296 268.231C675.176 268.303 675.13 268.36 675.114 268.388C675.13 268.415 675.176 268.472 675.296 268.544C675.506 268.67 675.845 268.772 676.261 268.772C676.676 268.772 677.015 268.67 677.225 268.544C677.345 268.472 677.391 268.415 677.408 268.388ZM675.105 268.368C675.105 268.368 675.105 268.369 675.105 268.371C675.105 268.369 675.105 268.368 675.105 268.368ZM675.105 268.407C675.105 268.407 675.105 268.406 675.105 268.404C675.105 268.406 675.105 268.407 675.105 268.407ZM677.416 268.404C677.416 268.406 677.417 268.407 677.417 268.407C677.417 268.407 677.416 268.406 677.416 268.404ZM676.261 269.542C677.323 269.542 678.184 269.025 678.184 268.388C678.184 267.75 677.323 267.234 676.261 267.234C675.198 267.234 674.337 267.75 674.337 268.388C674.337 269.025 675.198 269.542 676.261 269.542Z"
      fill="black"
    />
    <circle cx={680.556} cy={263.323} r={0.70523} fill="#0C102B" />
    <ellipse
      cx={6.21648}
      cy={6.88709}
      rx={6.21648}
      ry={6.88709}
      transform="matrix(-0.288787 -0.957393 0.972822 -0.231554 703.362 222.897)"
      fill="url(#paint32_radial_30_42)"
    />
    <ellipse
      cx={9.81052}
      cy={10.8688}
      rx={9.81052}
      ry={10.8688}
      transform="matrix(-0.288787 -0.957393 0.972822 -0.231554 698.41 295.935)"
      fill="url(#paint33_radial_30_42)"
    />
    <path
      d="M1 368.536C1 368.536 23.0399 354.018 76.1361 355.055C129.232 356.092 151.272 370.351 185.835 368.536C220.397 366.721 251.955 343.129 294.532 342.092C337.109 341.055 363.657 350.388 388.201 349.869C412.746 349.351 430.779 324.721 457.828 323.943C509.841 322.448 531.962 390.055 609.603 385.907C683.976 381.933 752.326 327.314 829 327.314"
      stroke="url(#paint34_linear_30_42)"
    />
    <path
      d="M726.992 262.676C764.492 232.054 828.992 219.991 828.992 219.991V413H588.492C588.492 413 618.492 392.586 635.992 374.491C653.492 356.396 689.492 293.297 726.992 262.676Z"
      fill="url(#paint35_linear_30_42)"
    />
    <path
      d="M828.992 219.991C828.992 219.991 764.492 232.054 726.992 262.676C689.492 293.297 653.492 356.396 635.992 374.491C618.492 392.586 588.492 413 588.492 413"
      stroke="url(#paint36_linear_30_42)"
      strokeWidth={2}
    />
    <ellipse
      cx={633.977}
      cy={264.124}
      rx={1.17243}
      ry={1.07473}
      fill="white"
      fillOpacity={0.92}
    />
    <circle
      opacity={0.93}
      cx={641.397}
      cy={259.918}
      r={0.86453}
      transform="rotate(138 641.397 259.918)"
      fill="#C7F5FF"
    />
    <circle
      opacity={0.86}
      cx={690.973}
      cy={241.243}
      r={0.913183}
      transform="rotate(-126 690.973 241.243)"
      fill="#5DE1FF"
    />
    <circle
      opacity={0.7}
      cx={719.961}
      cy={261.72}
      r={1.18265}
      transform="rotate(67 719.961 261.72)"
      fill="#5DE1FF"
    />
    <circle
      opacity={0.79}
      cx={626.61}
      cy={285.082}
      r={0.67366}
      transform="rotate(-16 626.61 285.082)"
      fill="white"
      fillOpacity={0.92}
    />
    <circle
      opacity={0.81}
      cx={651.543}
      cy={276.977}
      r={1.27995}
      transform="rotate(140 651.543 276.977)"
      fill="#B3C3FF"
      fillOpacity={0.92}
    />
    <circle
      cx={724.381}
      cy={277.1}
      r={1.57187}
      transform="rotate(100 724.381 277.1)"
      fill="#C9F5FF"
    />
    <circle
      cx={709.295}
      cy={205.821}
      r={1.57187}
      transform="rotate(100 709.295 205.821)"
      fill="#2340B8"
    />
    <circle
      cx={699.586}
      cy={219.677}
      r={0.892974}
      transform="rotate(100 699.586 219.677)"
      fill="#2340B8"
    />
    <circle
      opacity={0.93}
      cx={596.822}
      cy={299.254}
      r={1.7066}
      transform="rotate(176 596.822 299.254)"
      fill="#9CEDFF"
    />
    <circle
      opacity={0.89}
      cx={662.656}
      cy={296.666}
      r={1.73655}
      transform="rotate(114 662.656 296.666)"
      fill="#5DE1FF"
    />
    <circle
      opacity={0.72}
      cx={730.087}
      cy={296.456}
      r={1.46708}
      transform="rotate(177 730.087 296.456)"
      fill="#5DE1FF"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 462.534 80.962)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 462.534 80.962)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 447.242 72.5276)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 447.242 72.5276)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 446.082 91.702)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 446.082 91.702)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 434.508 114.941)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 434.508 114.941)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 454.739 108.966)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 454.739 108.966)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 474.727 112.208)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 474.727 112.208)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 405.842 136.207)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 405.842 136.207)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 386.393 157.718)"
      fill="#2802B5"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 386.393 157.718)"
      fill="#2802B5"
    />
    <circle
      cx={4}
      cy={4}
      r={4}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 427.863 95.4509)"
      fill="#4340B8"
    />
    <circle
      cx={3}
      cy={3}
      r={3}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 504.814 119.19)"
      fill="#4340B8"
    />
    <circle
      cx={3}
      cy={3}
      r={3}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 390.311 208.386)"
      fill="#1714A5"
    />
    <circle
      cx={3.5}
      cy={3.5}
      r={3.5}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 537.265 229.421)"
      fill="#4DCBF3"
    />
    <circle
      cx={2}
      cy={2}
      r={2}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 407.526 156.544)"
      fill="#4340B8"
    />
    <circle
      cx={2}
      cy={2}
      r={2}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 425.585 148.666)"
      fill="#4340B8"
    />
    <circle
      cx={3}
      cy={3}
      r={3}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 404.865 173.072)"
      fill="#4340B8"
    />
    <circle
      cx={2}
      cy={2}
      r={2}
      transform="matrix(-0.670672 0.741754 0.741754 0.670672 381.138 179.931)"
      fill="#4340B8"
    />
    <path
      d="M100 405C108.033 379.693 119.095 317.051 147.665 310.5C167.292 306 197.2 356 218.696 353C240.192 350 248.137 320 257.015 316.5C265.894 313 275.708 321 275.708 321"
      stroke="url(#paint37_linear_30_42)"
    />
    <path
      d="M102.337 403.5C117.029 384.543 126.637 351.5 146.263 346C177.196 337.332 204.677 380 228.042 388C251.408 396 257.95 381.5 276.642 388C295.335 394.5 303.279 408.5 303.279 408.5"
      stroke="url(#paint38_linear_30_42)"
    />
    <path
      d="M147.198 408C147.198 408 156.077 386 178.04 374C200.249 361.866 231.313 352.5 243.463 337.5C255.613 322.5 253.744 317.5 262.623 309.5C271.502 301.5 270.567 304.5 282.717 294.5C294.867 284.5 304.681 254 315.429 251.5C326.177 249 348.14 265.5 348.14 265.5"
      stroke="url(#paint39_linear_30_42)"
    />
    <path
      d="M260 413C260 413 264.054 380.32 275.727 364.783C287.399 349.247 305.141 348.175 317.747 334.781C330.354 321.388 356.033 265.135 373.308 265.135C390.583 265.135 415.329 275.314 429.336 265.135C443.343 254.956 495.168 177.273 516.646 171.38C538.123 165.486 558.199 177.953 591.816 159.593C625.433 141.234 613.992 55.2701 660.917 48.1586C685.662 44.4084 689.865 61.5522 719.746 60.4807C749.627 59.4092 776.241 36.908 792.582 35.3008C808.923 33.6936 811.258 39.051 818.261 39.051C825.265 39.051 829 35.3008 829 35.3008"
      stroke="url(#paint40_linear_30_42)"
      strokeOpacity={0.5}
    />
    <path
      d="M569.644 172C569.644 172 583.664 167 590.673 152C607.376 116.256 620.581 54.5 625.254 42C629.927 29.5 641.61 4 641.61 4"
      stroke="url(#paint41_linear_30_42)"
    />
    <path
      d="M337 279C337.748 275.8 347.206 240 357.486 233C367.767 226 390.198 227 396.74 220.5C403.283 214 409.358 195 416.367 189.5C423.377 184 438.331 176.5 444.873 170C451.415 163.5 442.069 120.5 474.313 106C506.558 91.5 518.708 108 533.194 109C547.681 110 553.288 101.5 563.569 101.5C573.85 101.5 584.131 109 584.131 109"
      stroke="url(#paint42_linear_30_42)"
    />
    <path
      d="M316 356C344.966 358.358 357.5 392.5 387.5 403C417.5 413.5 467.875 397.744 480.7 401.152C493.525 404.559 516.5 413.5 516.5 413.5"
      stroke="url(#paint43_linear_30_42)"
    />
    <path
      d="M121.496 291C121.496 291 140.188 265 164.021 267C187.854 269 197.2 308 221.5 312C245.8 316 284.586 279.5 284.586 279.5"
      stroke="url(#paint44_linear_30_42)"
    />
    <circle
      cx={662.107}
      cy={161.107}
      r={20.5}
      transform="rotate(-75 662.107 161.107)"
      fill="url(#paint45_radial_30_42)"
    />
    <circle
      cx={658.648}
      cy={172.086}
      r={1}
      transform="rotate(-75 658.648 172.086)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M659.897 162.477C659.7 162.285 659.696 161.968 659.889 161.77C661.432 160.189 661.401 157.657 659.82 156.114C659.622 155.921 659.618 155.604 659.811 155.407C660.004 155.209 660.321 155.205 660.518 155.398C662.495 157.327 662.533 160.493 660.604 162.469C660.411 162.666 660.095 162.67 659.897 162.477Z"
      fill="black"
    />
    <circle
      cx={657.58}
      cy={149.024}
      r={1}
      transform="rotate(-75 657.58 149.024)"
      fill="#0C102B"
    />
    <circle
      cx={548.729}
      cy={40.1669}
      r={18.5716}
      transform="rotate(18.3493 548.729 40.1669)"
      fill="url(#paint46_radial_30_42)"
    />
    <circle
      cx={548.729}
      cy={40.1669}
      r={18.5716}
      transform="rotate(18.3493 548.729 40.1669)"
      fill="url(#paint47_radial_30_42)"
    />
    <circle
      cx={548.729}
      cy={40.1669}
      r={18.5716}
      transform="rotate(18.3493 548.729 40.1669)"
      fill="url(#paint48_radial_30_42)"
    />
    <circle
      cx={539.068}
      cy={36.4384}
      r={0.932679}
      transform="rotate(18.3493 539.068 36.4384)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M547.947 38.1253C548.137 37.9518 548.432 37.9654 548.605 38.1558C549.993 39.6786 552.353 39.7879 553.876 38.4C554.066 38.2265 554.361 38.2402 554.534 38.4305C554.708 38.6209 554.694 38.9158 554.504 39.0893C552.6 40.8242 549.651 40.6876 547.916 38.7841C547.743 38.5937 547.756 38.2987 547.947 38.1253Z"
      fill="black"
    />
    <circle
      cx={560.599}
      cy={36.7011}
      r={0.932679}
      transform="rotate(18.3493 560.599 36.7011)"
      fill="#0C102B"
    />
    <path
      d="M567.44 39.5845C580.599 45.417 589.049 51.3338 587.972 54.5807C586.473 59.1006 567.078 56.735 544.652 49.2969C522.226 41.8588 505.262 32.1648 506.761 27.6449C507.879 24.2741 518.949 24.7327 533.807 28.2686"
      stroke="url(#paint49_linear_30_42)"
    />
    <path
      d="M560.391 39.296C569.655 43.4565 575.59 47.6916 574.807 50.0324C573.716 53.2912 560.019 51.6452 544.213 46.3561C528.407 41.0669 516.478 34.1375 517.569 30.8788C518.382 28.4486 526.206 28.7461 536.687 31.2481"
      stroke="url(#paint50_linear_30_42)"
    />
    <path
      d="M572.357 41.2221C589.186 48.6873 599.992 56.2659 598.61 60.4311C596.687 66.2296 571.875 63.2176 543.191 53.7037C514.506 44.1899 492.812 31.7768 494.735 25.9784C496.169 21.6542 510.333 22.2298 529.339 26.7478"
      stroke="url(#paint51_linear_30_42)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_30_42"
        x1={785.5}
        y1={31.2338}
        x2={39.2648}
        y2={349.327}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D10AC" stopOpacity={0.66} />
        <stop offset={1} stopColor="#0F00B8" stopOpacity={0.76} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30_42"
        x1={318.797}
        y1={248.268}
        x2={318.797}
        y2={281.326}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#334BCA" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_30_42"
        x1={318.797}
        y1={240.397}
        x2={318.797}
        y2={289.197}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#334BCA" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_30_42"
        x1={318.977}
        y1={230.818}
        x2={318.977}
        y2={297.722}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#334BCA" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_30_42"
        x1={318.797}
        y1={221.506}
        x2={318.797}
        y2={308.087}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#334BCA" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <radialGradient
        id="paint5_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(322.758 269.103) rotate(-131.711) scale(21.247)"
      >
        <stop stopColor="#1E18D2" />
        <stop offset={0.355} stopColor="#3832DB" />
        <stop offset={1} stopColor="#B468EF" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(322.068 268.413) rotate(-129.611) scale(12.9796 11.1664)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(319.538 265.266) rotate(42.4364) scale(9.00827)"
      >
        <stop offset={0.767539} stopColor="#0019FF" stopOpacity={0} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_30_42"
        x1={446}
        y1={129.054}
        x2={750.566}
        y2={371.23}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1890E5" />
        <stop offset={0.33} stopColor="#3B63E9" />
        <stop offset={1} stopColor="#002AB3" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_30_42"
        x1={698}
        y1={171.5}
        x2={147}
        y2={389.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5F83FF" />
        <stop offset={1} stopColor="#1F347D" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint10_linear_30_42"
        x1={615.5}
        y1={160.14}
        x2={692.425}
        y2={278.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0911019} stopColor="#275AFF" />
        <stop offset={1} stopColor="#1C1D5C" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_30_42"
        x1={762.5}
        y1={104}
        x2={566}
        y2={410.232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5473FF" />
        <stop offset={1} stopColor="#5977FF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint12_linear_30_42"
        x1={415}
        y1={172.203}
        x2={574.69}
        y2={469.76}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C9F8FF" />
        <stop offset={0.46} stopColor="#2AE5FF" stopOpacity={0.74} />
        <stop offset={1} stopColor="#4BA4DE" stopOpacity={0.46} />
      </linearGradient>
      <radialGradient
        id="paint13_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(392.178 295.278) rotate(108.104) scale(18.07)"
      >
        <stop stopColor="#FFB6FC" />
        <stop offset={1} stopColor="#A9318F" />
      </radialGradient>
      <linearGradient
        id="paint14_linear_30_42"
        x1={679}
        y1={306.5}
        x2={217}
        y2={396}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#216288" />
        <stop offset={0.18} stopColor="#41CAE7" />
        <stop offset={0.33} stopColor="#E4FFFF" />
        <stop offset={1} stopColor="#1E9CBC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_30_42"
        x1={502.5}
        y1={162}
        x2={502.5}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92FDFF" />
        <stop offset={1} stopColor="#63F4F7" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_30_42"
        x1={517.5}
        y1={205}
        x2={517.5}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#63B4EB" />
        <stop offset={1} stopColor="#3C55BA" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_30_42"
        x1={532.5}
        y1={185}
        x2={532.5}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#46B5FA" />
        <stop offset={1} stopColor="#2D42AF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_30_42"
        x1={547.5}
        y1={218}
        x2={547.5}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6B99DD" />
        <stop offset={1} stopColor="#314FAF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_30_42"
        x1={562.5}
        y1={247}
        x2={562.5}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3990FF" />
        <stop offset={1} stopColor="#4D8BD6" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_30_42"
        x1={205.871}
        y1={297.328}
        x2={637.47}
        y2={352.391}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C29CC" stopOpacity={0.05} />
        <stop offset={1} stopColor="#002A98" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_30_42"
        x1={74.5}
        y1={382}
        x2={570.5}
        y2={383}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.355} stopColor="#8386FF" stopOpacity={0} />
        <stop offset={0.618741} stopColor="#94ECFF" />
        <stop offset={1} stopColor="#456DDE" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_30_42"
        x1={205.871}
        y1={327.317}
        x2={696.633}
        y2={418.321}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C29CC" stopOpacity={0.68} />
        <stop offset={0.255325} stopColor="#192AAE" stopOpacity={0.8656} />
        <stop offset={0.755} stopColor="#001856" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_30_42"
        x1={698}
        y1={339.5}
        x2={95.5}
        y2={383}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#97A8FF" />
        <stop offset={0.24} stopColor="#0C2ABB" />
        <stop offset={0.59} stopColor="#00C2FF" />
        <stop offset={1} stopColor="#2A44C3" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_30_42"
        x1={673}
        y1={244}
        x2={673}
        y2={286}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5AD5FB" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint25_linear_30_42"
        x1={673}
        y1={234}
        x2={673}
        y2={296}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5AD5FB" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint26_linear_30_42"
        x1={672.293}
        y1={222.479}
        x2={672.293}
        y2={307.479}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5AD5FB" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="paint27_linear_30_42"
        x1={673}
        y1={210}
        x2={673}
        y2={320}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5AD5FB" />
        <stop offset={1} stopColor="#1E246E" stopOpacity={0.33} />
      </linearGradient>
      <radialGradient
        id="paint28_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(678.917 269.358) rotate(-131.711) scale(27.215)"
      >
        <stop stopColor="#189AD2" />
        <stop offset={0.355} stopColor="#32BDDB" />
        <stop offset={1} stopColor="#68EFCF" />
      </radialGradient>
      <radialGradient
        id="paint29_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(678.033 268.475) rotate(-129.611) scale(16.6254 14.3029)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint30_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(674.5 264.5) rotate(90) scale(11.9248)"
      >
        <stop offset={0.693364} stopColor="white" />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint31_linear_30_42"
        x1={661.245}
        y1={262.193}
        x2={680.542}
        y2={256.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="white" stopOpacity={0.27} />
      </linearGradient>
      <radialGradient
        id="paint32_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.15205 3.82616) rotate(106.441) scale(10.3721 9.53269)"
      >
        <stop stopColor="#585FFF" />
        <stop offset={1} stopColor="#182B72" />
      </radialGradient>
      <radialGradient
        id="paint33_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.4433 6.03825) rotate(106.441) scale(16.3687 15.044)"
      >
        <stop stopColor="#2D79D3" />
        <stop offset={1} stopColor="#182B72" />
      </radialGradient>
      <linearGradient
        id="paint34_linear_30_42"
        x1={537.5}
        y1={318.294}
        x2={520.505}
        y2={410.531}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4664FF" stopOpacity={0.37} />
        <stop offset={1} stopColor="#6865F8" stopOpacity={0.23} />
      </linearGradient>
      <linearGradient
        id="paint35_linear_30_42"
        x1={709.742}
        y1={219.991}
        x2={773.803}
        y2={416.006}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F2F8F" stopOpacity={0.6} />
        <stop offset={0.695} stopColor="#131368" />
        <stop offset={1} stopColor="#100E36" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_30_42"
        x1={708.742}
        y1={219.991}
        x2={708.742}
        y2={413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#424AC4" />
        <stop offset={1} stopColor="#191F7E" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_30_42"
        x1={265.894}
        y1={334}
        x2={121.687}
        y2={383.212}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#275AFF" stopOpacity={0} />
        <stop offset={0.55} stopColor="#5075EE" />
        <stop offset={1} stopColor="#275AFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint38_linear_30_42"
        x1={199.537}
        y1={346.5}
        x2={203.28}
        y2={408.471}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#547CFF" />
        <stop offset={1} stopColor="#464EFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint39_linear_30_42"
        x1={327.111}
        y1={264}
        x2={145.582}
        y2={395.602}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#275AFF" stopOpacity={0} />
        <stop offset={0.585} stopColor="#275AFF" />
        <stop offset={1} stopColor="#7A9AFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint40_linear_30_42"
        x1={544.659}
        y1={35}
        x2={544.659}
        y2={404.964}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3B58D6" />
        <stop offset={0.355} stopColor="white" />
        <stop offset={1} stopColor="#4072F4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint41_linear_30_42"
        x1={641.61}
        y1={3.5}
        x2={561.168}
        y2={171.44}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4685FF" stopOpacity={0} />
        <stop offset={0.505} stopColor="#625FFF" />
        <stop offset={1} stopColor="#4340B8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint42_linear_30_42"
        x1={406.554}
        y1={128}
        x2={461.677}
        y2={200.985}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DABE2" />
        <stop offset={1} stopColor="#4664FF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint43_linear_30_42"
        x1={324.775}
        y1={358.556}
        x2={517.728}
        y2={383.946}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A46FF" stopOpacity={0} />
        <stop offset={0.5} stopColor="#63A1F6" />
        <stop offset={1} stopColor="#2802B5" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint44_linear_30_42"
        x1={135.515}
        y1={287}
        x2={264.119}
        y2={296.179}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4340B8" stopOpacity={0} />
        <stop offset={0.679456} stopColor="#3F58D9" />
        <stop offset={1} stopColor="#3F58D9" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="paint45_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(661.607 153.107) rotate(88.9949) scale(28.5044)"
      >
        <stop stopColor="#F4C386" />
        <stop offset={0.53} stopColor="#F0989F" />
        <stop offset={1} stopColor="#D22B6F" />
      </radialGradient>
      <radialGradient
        id="paint46_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(542.428 30.5494) rotate(61.5788) scale(32.0522)"
      >
        <stop stopColor="#F4B0FF" />
        <stop offset={0.68} stopColor="#0017FF" />
        <stop offset={1} stopColor="#002325" />
      </radialGradient>
      <radialGradient
        id="paint47_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(539.111 17.284) rotate(67.6771) scale(54.1339)"
      >
        <stop stopColor="#A4A5FF" stopOpacity={0} />
        <stop offset={0.479951} stopColor="#4346FF" stopOpacity={0.29} />
        <stop offset={1} stopColor="#91FFD7" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint48_radial_30_42"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(548.729 38.5087) rotate(125.803) scale(24.9434)"
      >
        <stop offset={0.622238} stopColor="#000AFF" stopOpacity={0} />
        <stop offset={1} stopColor="#0038FF" />
      </radialGradient>
      <linearGradient
        id="paint49_linear_30_42"
        x1={549.861}
        y1={33.5931}
        x2={544.652}
        y2={49.2969}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_30_42"
        x1={548.002}
        y1={35.0342}
        x2={544.213}
        y2={46.3561}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_30_42"
        x1={549.872}
        y1={33.5582}
        x2={543.191}
        y2={53.7037}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
